import React, { Fragment, useEffect, useState } from 'react';
import Button from '../../../common/Button';
import styled from '@emotion/styled';
import TableRow from '../TableRow';
import SpinnerBlock from '../../../common/SpinnerBlock';
import QuantityPicker from '../../../common/QuantityPicker';
import { getCurrencySymbol, getItemsString } from '../../../../helpers';
import numeral from 'numeral';

const Wrapper = styled('div')`
  .quantity-picker-wrapper {
    margin-left: 30px;
    border: 1px solid #ced4da;
    border-radius: 4px;
    padding: 2px;
    min-width: 80px;
  }
  .quantity-static-value {
    margin-left: 5px;
  }
  .table tbody {
    border-bottom: 1px solid #dee2e6;
  }
  th .light {
    font-weight: 400;
  }
  .red {
    color: #ff95a4;
    font-size: 12px;
    line-height: 12px;
  }
`;

const DekstopComponent = (props) => {
  const {
    data,
    handleUpdateOptional,
    handleUpdateBundleOptionalCount,
    handleNewItem,
    handleRemoveItem,
    loading,
    currentQuantityInput,
    currentQuantityInputValue,
    handleToggleQuantityInput,
    handleUpdateQuantity,
    setCurrentQuantityInputValue,
    setCurrentQuantityInput,
    allowVariativeBundles,
    isNew,
    openItem,
    requiredQuantity,
  } = props;

  const compareItems = (a, b) => {
    if (b.price === a.price) {
      return a.variantId - b.variantId;
    }
    return b.price - a.price;
  };

  return (
    <Wrapper className="card-box">
      <div className="row mb-2">
        <div className="col-12">
          <h4 className="header-title" style={{ marginBottom: '10px' }}>
            Состав набора
          </h4>
        </div>
      </div>
      <div className="row mb-3 d-flex justify-content-between">
        <div className="col-md-3">
          <Button
            type="button"
            text={'Добавить товар'}
            icon="fe-plus"
            classType="btn btn-light"
            className="ml-auto"
            onClick={() => handleNewItem()}
          />
        </div>
        <div className="col-md-6">
          {data && allowVariativeBundles && !isNew && (
            <div className="d-flex justify-content-end align-items-center">
              <div className="text-right">
                <div className="font-14">
                  Необходимое количество товаров для добавления набора в заказ
                </div>
                <div className="red">Не зависит от количества самого товара в наборе</div>
              </div>
              <QuantityPicker
                value={data?.bundleOptionalCount + requiredQuantity}
                min={requiredQuantity}
                max={data?.length}
                reverse
                onChange={(value) => handleUpdateBundleOptionalCount(value)}
              />
            </div>
          )}
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="fixed-table-container">
            <div className="fixed-table-body">
              {data && (
                <table className="table table-centered">
                  <thead className="thead-light">
                    <tr>
                      <th></th>
                      <th>
                        <div>Наименование</div>
                        <div className="light">{getItemsString(data.items.length)}</div>
                      </th>
                      <th></th>
                      <th>
                        <div>Цена</div>
                        <div className="light">
                          Цена набора:{' '}
                          {`${numeral(
                            data.items.reduce((acc, elem) => acc + elem.price * elem.quantity, 0),
                          ).format('0,0.[00]')} ${getCurrencySymbol('RUB')}`}
                        </div>
                      </th>
                      <th>
                        <div>Количество</div>
                        <div className="light">
                          Общ. кол-во: {data.items.reduce((acc, elem) => acc + elem.quantity, 0)}
                        </div>
                      </th>
                      {allowVariativeBundles && !isNew && (
                        <th>
                          <div className="text-center">
                            Обязательный <br /> товар
                          </div>
                        </th>
                      )}
                      <th></th>
                    </tr>
                  </thead>
                  {!loading ? (
                    <tbody>
                      {data.items?.sort(compareItems).map((item, i) => (
                        <>
                          <TableRow
                            key={item.variantId}
                            i={i}
                            item={item}
                            handleUpdateOptional={handleUpdateOptional}
                            currentQuantityInput={currentQuantityInput}
                            currentQuantityInputValue={currentQuantityInputValue}
                            handleToggleQuantityInput={handleToggleQuantityInput}
                            handleUpdateQuantity={handleUpdateQuantity}
                            setCurrentQuantityInputValue={setCurrentQuantityInputValue}
                            setCurrentQuantityInput={setCurrentQuantityInput}
                            handleRemoveItem={handleRemoveItem}
                            allowVariativeBundles={allowVariativeBundles}
                            isNew={isNew}
                            openItem={openItem}
                            variative
                          />
                        </>
                      ))}
                    </tbody>
                  ) : null}
                </table>
              )}
              {loading ? (
                <div style={{ width: '100%', position: 'relative', height: '150px ' }}>
                  <SpinnerBlock show={loading} />
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default DekstopComponent;
